const authTypes = {
  SET_CURRENT_USER: 'SET_CURRENT_USER',
  FETCH_SECURITY_QUESTIONS: 'FETCH_SECURITY_QUESTIONS',
  VERIFY_OTP: 'VERIFY_OTP',
};

export default authTypes;
